import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function MoveCategoryDialog({ open, categoryName, options, initialParent, onClose, onSave }: {
  open: boolean; categoryName: string; options: Array<{ id: string; name: string }>; initialParent?: string;
  onClose: () => void; onSave: (parentId?: string) => Promise<void>;
}) {
  const { t } = useTranslation();
  const [parent, setParent] = useState(initialParent || '');
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setParent(initialParent || ''); }, [open, initialParent]);
  const save = async () => { setSaving(true); try { await onSave(parent || undefined); onClose(); } finally { setSaving(false); } };
  return <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>{t('entity_list.codex.tabs.move_category_title', { category: categoryName })}</DialogTitle>
    <DialogContent>
      <TextField select autoFocus fullWidth margin="dense" label={t('entity_list.codex.tabs.parent_category')} value={parent} onChange={(e) => setParent(e.target.value)} disabled={saving}>
        <MenuItem value="">{t('entity_list.codex.tabs.none_top_level')}</MenuItem>
        {options.map((option) => <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)}
      </TextField>
    </DialogContent>
    <DialogActions><Button onClick={onClose} disabled={saving}>{t('common.cancel')}</Button><Button onClick={() => void save()} variant="contained" disabled={saving}>{t('common.save')}</Button></DialogActions>
  </Dialog>;
}
